<template>
  <div class="container px-4 mx-auto text-center">
    <h1 class="text-5xl font-semibold pt-8">{{ $t('gallery') }}</h1>
    <p class="text-gray-600 mb-4">{{ $t('gallery_look') }}</p>
    <no-ssr>
      <gallery :images="images" :index="index" @close="index = null"></gallery>
      <div
        class="container mx-auto images flex flex-wrap justify-center align-start py-4 xl:py-18"
      >
        <div
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
          :style="{
            background: `url('${image}')`,
            backgroundSize: 'cover',
            width: '300px',
            height: '200px'
          }"
          @click="index = imageIndex"
          class="image"
        ></div>
      </div>
    </no-ssr>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      image_count: 15,
      index: null
    }
  },
  computed: {
    images() {
      const array = []
      for (let i = 1; i < this.image_count; i++) {
        array.push(`/img/gallery/img (${i}).JPG`)
      }
      return array
    }
  },
  mounted() {
    for (let i = 1; i < this.image_count; i++) {
      this.images.push(`/img/gallery/img (${i}).JPG`)
    }
  }
}
</script>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.image {
  @apply m-3;
  background-size: contain;
  background-position: center;
  width: 250px;
  height: 250px;
}
</style>
